import { messages } from './messages.constants';

export { messagesActions, errorMessagesActions } from './messages-actions';

export { messagesReducer } from './messages.reducer';
export { ConnectedMessages as Messages } from './Messages';
export { ConnectedMessages as ModalMessages } from './ModalMessages';
export { SingleErrorMessage, SingleModalErrorMessage } from './single-error-message';
export {
  SingleMessage,
  AppointmentTypeNotFoundMessage,
  BeautyToBeautySocietyPartnersNotFound,
} from './single-message';
export {
  errors as errorTypes,
  success as successTypes,
  info as infoTypes,
} from './messages.constants';
export { ConnectedScrollToMessageTypeAnchor as scrollToMessageTypeAnchor } from './scroll-to-message-type-anchor.hoc';

export const { errors: errorMessages, successes: successMessages, info: infoMessages } = messages;

export { errorMessagesSelectors, messagesSelectors } from './messages.selectors';

export { ConnectedWithMessageBanner as withMessageBanner } from './with-message-banner.hoc';
